import React from 'react';
import update from 'immutability-helper';
import { browserHistory } from 'react-router'

import UnitedStatesSelect from '../../../helpers/General/UnitedStatesSelect';

import { phoneNumberFormatter } from '../../../helpers/General/PhoneNunberFormatter';
import { ssnFormatter } from '../../../helpers/General/SSNFormatter'
import { creditCardFormatter } from '../../../helpers/General/CreditCardFormatter';
import { tenant } from '../../../core/controllers/Tenant';
import { rentProScreening } from '../../../core/controllers/RentProScreening';
import { modal } from '../../../core/utilities/modal';
export default class Screening extends React.Component {
    constructor(props) {
        super(props);
        var self = this;

        this.state = {
            tenantID : props.tenantID,
            contract_data_id: 0,
            space_id: 0,
            attachments: null,
            tenantData: {
                tenant_phone: '',
                tenant_firstname: '',
                tenant_lastname: '',
                tenant_middlename: '',
                tenant_email: '',
                tenant_dob: '',
                tenant_streetAddress: '',
                tenant_city: '',
                tenant_state: '',
                tenant_postalCode: '',
                tenant_ssn: '',
                tenant_fax: ''
            },
            customerData: {
                credit_card: {
                    card_number: '',
                    card_security: '',
                    card_type: '',
                    expire_month: '',
                    expire_year: ''
                },
                customer_streetAddress: '',
                customer_city: '',
                customer_state: '',
                customer_postalCode: '',
                customer_companyName: '',
                customer_email: '',
                customer_firstname: '',
                customer_lastname: '',
                customer_phone: '',
                customer_tenantId: props.tenantID
            }
        };
    }

    componentDidMount() {
        var self = this;
        tenant.setTenantID(this.state.tenantID);
        tenant.getTenant(this);
        jQuery('#dob').datepicker({
            yearRange: "-100:-10",
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handleDobChange(e);
            }
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.screening !== undefined && nextState.screening !== null) {
            modal.showInfo("This tenant was already screened!", "warning", "top", "center");
            browserHistory.replace('/tenants');
        }
    }

    triggerScreening() {
        var self = this;
        modal.showDangerModalWithOK("Are you sure?","Your data is encrypted and secure.  With continuing, you will be charged $22.95.  Continue?","Yes");
        jQuery(".move-on").on('click',function() {
            modal.resetBackDrop();
            const tenantData = self.state.tenantData;
            const customerData = self.state.customerData;
            var validated = true;
            if(tenantData.tenant_phone == '' || typeof tenantData.tenant_phone == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s phone number.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_firstname == '' || typeof tenantData.tenant_firstname == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s firstname.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_lastname == '' || typeof tenantData.tenant_lastname == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s lastname.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_streetAddress == '' || typeof tenantData.tenant_streetAddress == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s street address.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_city == '' || typeof tenantData.tenant_city == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s city.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_dob == '' || typeof tenantData.tenant_dob == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s date of birth.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_state == '' || typeof tenantData.tenant_state == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s state.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_postalCode == '' || typeof tenantData.tenant_postalCode == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s postal code.', 'warning', 'top', 'center');
                return;
            }
            if(tenantData.tenant_ssn == '' || typeof tenantData.tenant_ssn == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the applicant\'s social security number.', 'warning', 'top', 'center');
                return;
            }

            if(customerData.credit_card.card_number == '' || typeof customerData.credit_card.card_number == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the credit card number to process this request.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.credit_card.card_type == '' || typeof customerData.credit_card.card_type == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need to know the card type.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.credit_card.card_security == '' || typeof customerData.credit_card.card_security == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the card security code on the back.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.credit_card.expire_month == '' || typeof customerData.credit_card.expire_month == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the card expiration date.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.credit_card.expire_year == '' || typeof customerData.credit_card.expire_year == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the card expiration date.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_city == '' || typeof customerData.customer_city == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the billing city.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_companyName == '' || typeof customerData.customer_companyName == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the company name requesting this screening.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_email == '' || typeof customerData.customer_email == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the billing email address.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_firstname == '' || typeof customerData.customer_firstname == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need your firstname.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_lastname == '' || typeof customerData.customer_lastname == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need your lastname.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_phone == '' || typeof customerData.customer_phone == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need your billing phone number.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_postalCode == '' || typeof customerData.customer_postalCode == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need the billing zipcode.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_state == '' || typeof customerData.customer_state == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need your billing state.', 'warning', 'top', 'center');
                return;
            }
            if(customerData.customer_streetAddress == '' || typeof customerData.customer_streetAddress == 'undefined') {
                validated = false;
                modal.showInfo('Missing Information! We need your billing address.', 'warning', 'top', 'center');
                return;
            }

            if(validated) {
                rentProScreening.screenTenant(self.state, function(response) {
                    modal.showSuccess("Order Placed!",  "We will notify you as soon as we have received your request background check.");
                    jQuery(".move-on").on('click',function() {
                        browserHistory.replace('/tenant/' + self.state.tenantID);
                    });
                });
            }
        });
    }

    handleFirstnameChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_email: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_phone: {$set: phoneNumber
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_email: {$set: e.target.value
                }}
            )
        });
    }

    handleMiddlenameChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_middlename: {$set: e.target.value
                }}
            )
        });
    }

    handleFaxChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_fax: {$set: e.target.value
                }}
            )
        });
    }

    handleDobChange(value){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_dob: {$set: value
                }}
            )
        });
    }

    handleSSNChange(e){
        var ssnNumber = ssnFormatter.format(e.target.value);

        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_ssn: {$set: ssnNumber
                }}
            )
        });
    }

    handleAddressChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_streetAddress: {$set: e.target.value
                }}
            )
        });
    }

    handleCityChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_city: {$set: e.target.value
                }}
            )
        });
    }

    handleStateChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_state: {$set: e.target.value
                }}
            )
        });
    }

    handleZipcodeChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_postalCode: {$set: e.target.value
                }}
            )
        });
    }

    /* Customer Information */
    handleCustomerCompanyNameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_companyName: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerCityChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_city: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerEmailChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_email: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerFirstnameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerLastnameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerPhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            customerData: update(this.state.customerData, {
                customer_phone: {$set: phoneNumber
                }}
            )
        });
    }

    handleCustomerStateChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_state: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerZipcodeChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_postalCode: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerAddressChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_streetAddress: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerCardNumber(e){
        var cardNumber = creditCardFormatter.format(e.target.value);

        this.setState({
            customerData: update(this.state.customerData, {
                credit_card: {
                    card_number: {$set: cardNumber}
                    }
                }
            )
        });
    }

    handleCustomerCardTypeChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                credit_card: {
                    card_type: {$set: e.target.value}
                    }
                }
            )
        });
    }

    handleCustomerSecurityCode(e){
        this.setState({
            customerData: update(this.state.customerData, {
                credit_card: {
                    card_security: {$set: e.target.value}
                    }
                }
            )
        });
    }

    handleCustomerExpMonthChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                credit_card: {
                    expire_month: {$set: e.target.value}
                    }
                }
            )
        });
    }

    handleCustomerExpYearChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                credit_card: {
                    expire_year: {$set: e.target.value}
                    }
                }
            )
        });
    }

    render(){
        const tenantData = this.state.tenantData;
        const customerData = this.state.customerData;
        return (
            <div>
            <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
            <div class="row blue-bottom-margin">
                <div class="col-md-8">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Applicant Information</h4>
                            <p class="category">This report will run the following: <b>SSN Verification, Eviction History, Bankruptcies Search, Judgement/Lien Search, U.S. Criminal Search, Sex Offender Search,</b> and <b>Homeland Security Search</b></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Firstname</label>
                                            <input type="text" value={tenantData.tenant_firstname} class="form-control tenant-info" name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="lastname">Lastname</label>
                                            <input type="text" value={tenantData.tenant_lastname} class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" onChange={this.handleLastnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="lastname">Middle Name (optional)</label>
                                            <input type="text" value={tenantData.tenant_middlename} class="form-control tenant-info" name="middlename" placeholder="Middle Name" id="middlename" onChange={this.handleMiddlenameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="email">Email Address (optional)</label>
                                            <input type="text" value={tenantData.tenant_email} class="form-control tenant-info" name="email" placeholder="Email Address" id="email" onChange={this.handleEmailChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Primary Phone</label>
                                            <input type="text" value={tenantData.tenant_phone} class="form-control tenant-info" name="primaryphone" placeholder="Phone Number" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">Fax (optional)</label>
                                            <input type="text" value={tenantData.tenant_fax} class="form-control tenant-info" name="fax" placeholder="Fax" id="fax" onChange={this.handleFaxChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Date of Birth</label>
                                            <input type="text" value={tenantData.tenant_dob} class="form-control tenant-info" name="dob" placeholder="Date of Birth" id="dob" onChange={this.handleDobChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">SSN</label>
                                            <input type="text" value={tenantData.tenant_ssn} class="form-control tenant-info" name="ssn" placeholder="xxx-xx-xxxx" id="ssn" onChange={this.handleSSNChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Address</label>
                                            <input type="text" value={tenantData.tenant_streetAddress} class="form-control tenant-info" name="dob" placeholder="Address" id="address" onChange={this.handleAddressChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">City</label>
                                            <input type="text" value={tenantData.tenant_city} class="form-control tenant-info" name="city" placeholder="City" id="city" onChange={this.handleCityChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <UnitedStatesSelect columnSize={12} sortID={tenantData.tenant_state} title="State" onChange={this.handleStateChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                         <div class="form-group">
                                            <label for="phone">Zipcode</label>
                                            <input type="text" value={tenantData.tenant_postalCode} class="form-control tenant-info" name="zipcode" placeholder="Zipcode" id="zipcode" onChange={this.handleZipcodeChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Payment Method</h4>
                            <p class="category">Screening Fee: $27.00</p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Company Name</label>
                                            <input type="text" value={customerData.customer_companyName} class="form-control tenant-info" name="companyname" placeholder="Company Name" id="companyname" onChange={this.handleCustomerCompanyNameChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Your Firstname</label>
                                            <input type="text" value={customerData.customer_firstname} class="form-control tenant-info" name="firstname" placeholder="Firstname" id="payment_firstname" onChange={this.handleCustomerFirstnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">Your Lastname</label>
                                            <input type="text" value={customerData.customer_lastname} class="form-control tenant-info" name="lastname" placeholder="Lastname" id="payment_lastname" onChange={this.handleCustomerLastnameChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Your Phone Number</label>
                                            <input type="text" value={customerData.customer_phone} class="form-control tenant-info" name="phone" placeholder="Phone Number" id="payment_phone" onChange={this.handleCustomerPhoneChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">Your Email Address</label>
                                            <input type="text" value={customerData.customer_email} class="form-control tenant-info" name="email" placeholder="Email" id="payment_email" onChange={this.handleCustomerEmailChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Credit Card Number</label>
                                            <input type="text" value={customerData.credit_card.card_number} class="form-control tenant-info" name="cardnumber" placeholder="Card Number" id="cardnumber" onChange={this.handleCustomerCardNumber.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Card Type</label>
                                            <select class="form-control" value={customerData.credit_card.card_type} onChange={this.handleCustomerCardTypeChange.bind(this)}>
                                                <option value="0">Select a Card Type</option>
                                                <option value="visa">Visa</option>
                                                <option value="mastercard">MasterCard</option>
                                                <option value="amex">American Express</option>
                                                <option value="discover">Discover</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="email">Exp Month</label>
                                            <input type="text" value={customerData.credit_card.expire_month} class="form-control tenant-info" name="expmonth" placeholder="01" id="expmonth" onChange={this.handleCustomerExpMonthChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="email">Exp Year</label>
                                            <input type="text" value={customerData.credit_card.expire_year} class="form-control tenant-info" name="expyear" placeholder="2024" id="expyear" onChange={this.handleCustomerExpYearChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Security Code</label>
                                            <input type="text" value={customerData.credit_card.card_security} class="form-control tenant-info" name="code" placeholder="656" id="code" onChange={this.handleCustomerSecurityCode.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="header" style={{paddingLeft: 0}}>
                                    <h4 class="title">Billing Information</h4>
                                    <p class="category"></p>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Billing Address</label>
                                            <input type="text" value={customerData.customer_streetAddress} class="form-control tenant-info" name="address" placeholder="Address" id="billing_address" onChange={this.handleCustomerAddressChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">Billing City</label>
                                            <input type="text" value={customerData.customer_city} class="form-control tenant-info" name="city" placeholder="City" id="billing_city" onChange={this.handleCustomerCityChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <UnitedStatesSelect columnSize={12} sortID={customerData.customer_state} title="Billing State" onChange={this.handleCustomerStateChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label for="phone">Billing Zipcode</label>
                                            <input type="text" value={customerData.customer_postalCode} class="form-control tenant-info" name="zipcode" placeholder="Zipcode" id="billing_zipcode" onChange={this.handleCustomerZipcodeChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.triggerScreening.bind(this)}>
                        Screen Now
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Tenant/Screening/Screening.jsx